import { createSelector } from 'reselect';
import { selectSearchTerm, selectItemUpdates } from '.';
import { isColor } from '../utilities';
import _ from 'lodash';
import { newStone } from '../actions';

const selectStones = state => state.stonesV2.stones;

const selectFabricatorStones = state => state.stonesV2.fabricatorStones;

const selectFilterGroups = state => state.stonesV2.filterGroups;

const selectSelectedFilters = state => state.stonesV2.selectedFilters;

const selectStoneUpdates = state => state.stonesV2.updates;

const selectPageSize = (state, pageSize) => pageSize;

export const getUpdatedStones = createSelector(
selectStones, selectFabricatorStones, selectStoneUpdates,
(stones, fabricatorStones, updates) => {
  let uStones = [];
  for(let stoneIndex in stones) {
    let stone = stones[stoneIndex];
    let newStoneData = {
      id: stone.id,
      name: stone.name,
      aliases: stone.aliases,
      imageUrl: stone.imageFullUrl,
      thumbUrl: stone.imageUrl,
      description: stone.longDescription,
      tags: stone.tags,
      filters: stone.filters,
      fabricatorStoneData: null,
      kVLayerCount: stone.kvLayerCount,
      createdById: stone.createdBy_id
    };
    let fStone = fabricatorStones.filter(s => s.stone_id == newStoneData.id);
    if(fStone.length > 0) {
      let newFStoneData = {
        id: fStone[0].id,
        stoneSupplierId: fStone[0].stoneSupplier_id,
        customStoneName: fStone[0].customStoneName,
        enabled: fStone[0].enabled,
        imageKey: fStone[0].imageKey,
        price: fStone[0].price,
        pricingPresetId: fStone[0].pricingPreset_id,
        profilePriceOverride: fStone[0].profilePriceOverride,
        slabSqftOverridePrice: fStone[0].slabSqftOverridePrice
      }
      let updatesForStone = updates.filter(u => u.id == fStone[0].id);
      for(let uIndex in updatesForStone) {
        let u = updatesForStone[uIndex];
        newFStoneData[u.key] = u.value;
      }
      newStoneData.fabricatorStoneData = newFStoneData;
    }
    uStones.push(newStoneData);
  }
  return uStones;
});

export const getFilteredUpdatedStones = createSelector(
  getUpdatedStones, selectSearchTerm, selectSelectedFilters, 
  (stones, term, filters) => {
    let lcTerm = _.trim(term.toLowerCase());
    let filteredStones = stones.filter(stone => {
      let valid = true;
      if(lcTerm.length > 0)
        valid = ((stone.name || "").toLowerCase().indexOf(lcTerm) >= 0 || 
              ((stone.fabricatorStoneData && stone.fabricatorStoneData.customStoneName) || "").toLowerCase().indexOf(lcTerm) >= 0 || 
              (stone.aliases || "").toLowerCase().indexOf(lcTerm) >= 0);

      if(valid && filters.length > 0) {
        valid = false;
        for(let i = 0; i < filters.length; i++) {
          let filter = filters[i];
          valid = valid || (_.findIndex(stone.filters, f => f.filterGroupValue_id == filter) >= 0);
        }
      }
      return valid;
    });
    return filteredStones;
  }
)

export const getFilteredEnabledUpdatedStones = createSelector(
  getFilteredUpdatedStones, (stones) => {
    return stones.filter(s => s.fabricatorStoneData && s.fabricatorStoneData.enabled);
  }
)